import React from 'react';
import {OS} from "../../../../../utils/CheckPlatform";
import {Reference} from "../../../../../res/Reference";

interface States {
}

interface Props {
}

class FaqButton extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    selectedOs = (os: OS) => {

    }

    render() {
        return (
            <div>
                <a
                    href={"#" + Reference.faqSection}>
                <span
                    className="faqButton">
                  FAQ
                </span>
                </a>
            </div>
        )
    }
}

export default FaqButton;
